<template>
    <div class="popup" :class="classObj">
        <van-popup :value="show" @click-overlay="close" @open="open">
            <accountForm ref="accountForm" v-if="memberRegisterType == 'UserName'" @close="close" @loginSucc="$emit('loginSucc')"></accountForm>
            <phoneForm ref="phoneForm" v-if="memberRegisterType == 'Phone'" @close="close" @loginSucc="$emit('loginSucc')"></phoneForm>
        </van-popup>
    </div>
</template>

<script>
import accountForm from './accountForm.vue'
import phoneForm from './phoneForm.vue'
import { mapState } from 'vuex'
export default {
    name: 'loginPopup',
    components: { accountForm, phoneForm },
    data() {
        return {}
    },
    props: {
        isCanClose: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        show: {
            get() {
                return this.$store.getters.isShowLoginPopup
            },
            set(val) {
                return val
            }
        },
        memberRegisterType() {
            const memberRegisterType = this.$store.getters.sysConfig?.memberRegisterType
            return memberRegisterType || 'UserName'
        }
    },
    created() { },
    methods: {
        close() {
            this.$store.dispatch('user/setIsShowLoginPopup', false)
            if (!this.isCanClose) {
                this.onNavTo({ url: '/RU', replace: 1 })
            }
        },
        open() {
            this.$nextTick(() => {
                if (this.memberRegisterType === 'UserName') {
                    this.$refs.accountForm.open()
                } else if (this.memberRegisterType === 'Phone') {
                    this.$refs.phoneForm.open()
                }
            })
        }
    },
    beforeDestroy() {
        this.$store.dispatch('user/changeLoginType', 2)
        this.$store.dispatch('user/setIsShowLoginPopup', false)
    }
}
</script>

<style scoped lang="scss">
.popup {
    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
    }

    &.mobile {
        // width: 100% !important;
        // height: 100% !important;

        .van-popup {
            &.van-popup--center {
                top: 6%;
                left: 0;
                transform: translate3d(0, 0, 0);
                width: 100% !important;
                height: 87% !important;
            }
        }
        ::v-deep .content{
            width: 100% !important;
            height: 87% !important;
            overflow-y: scroll;
        }
        ::v-deep .banner_pc {
            display: none;
        }

        ::v-deep .LogReg {
            width: 100% !important;
            height: 87% !important;
        }
    }
}</style>
